import { render } from "./Load.vue?vue&type=template&id=14dbbde9"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"

import "./Load.vue?vue&type=style&index=0&id=14dbbde9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__